"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerOverlay = exports.DrawerContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _vaul = require("vaul");
var DrawerOverlay = exports.DrawerOverlay = function DrawerOverlay(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_vaul.Drawer.Overlay, {
    className: className
  });
};
var DrawerContent = exports.DrawerContent = function DrawerContent(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    onClose = _ref2.onClose,
    setContentRef = _ref2.setContentRef;
  return /*#__PURE__*/_react["default"].createElement(_vaul.Drawer.Content, {
    className: className,
    "data-testid": "hb-drawer--container",
    onEscapeKeyDown: onClose,
    onPointerDownOutside: onClose,
    ref: setContentRef
  }, children);
};
//# sourceMappingURL=HBDrawerComponents.js.map